// goals.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_GOAL,
  ADD_GOALS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Goal.
 * @module reducer/goal
 */
const goals = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_GOAL:
      return _ADD_GOAL(action.payload)(state);
    case ADD_GOALS:
      return _ADD_GOALS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add goal
 * @kind reducer/actionType
 * @name ADD_GOAL
 * @param {object} goal - goal
 * @param {string} goal.id - goal id
 * @return {Immutable.Map} New state
 */
const _ADD_GOAL =
  ({ id, levels, ...goalData }) =>
  state => {
    const newLevels = levels || state.getIn([id, 'levels'])?.toJS() || [];
    return state
      .mergeDeep({ [id]: { id, ...goalData } })
      .setIn([id, 'levels'], fromJS(newLevels));
  };

/**
 * Add goals
 * @kind reducer/actionType
 * @name ADD_GOALS
 * @param {object} goals - goals
 * @return {Immutable.Map} New state
 */
const _ADD_GOALS =
  ({ goals }) =>
  state => {
    return state.mergeDeep(goals);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default goals;
